import { DataGridHead, DataGridHeader, DataGridRow } from '@twilio-paste/core/data-grid';

export function AppsTableHeader() {
  return (
    <DataGridHead>
      <DataGridRow>
        <DataGridHeader>App Name</DataGridHeader>
        <DataGridHeader>App ID</DataGridHeader>
        <DataGridHeader>App Code</DataGridHeader>
        <DataGridHeader textAlign="center">Status</DataGridHeader>
        <DataGridHeader textAlign="center">Actions</DataGridHeader>
      </DataGridRow>
    </DataGridHead>
  );
}
